module.exports = __webpack_public_path__ + "img/registered-mtr-icon.72c7d2be.svg";